import React from "react";
import { fmtFCFA } from "../lib/format";
import { AlertTriangle } from "lucide-react";

export default function Money({ value, className = "", showIcon = true }) {
  const v = Number(value || 0);
  const negative = v < 0;
  if (negative) {
    return (
      <span
        className={`inline-flex items-center gap-1 font-mono-num font-bold text-red-600 bg-red-50 px-2 py-0.5 rounded border border-red-200 ${className}`}
        data-testid="money-negative"
      >
        {showIcon && <AlertTriangle className="h-3.5 w-3.5" />}
        {fmtFCFA(v)}
      </span>
    );
  }
  return (
    <span className={`font-mono-num font-semibold text-emerald-700 ${className}`}>
      {fmtFCFA(v)}
    </span>
  );
}
